module.exports = __webpack_public_path__ + "static/media/C031.cb924fe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C031.jpg
// module id = 314
// module chunks = 0